import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "relative z-10 flex flex-col justify-center" };
const _hoisted_2 = { class: "max-w-5xl" };
const _hoisted_3 = { class: "mb-6 overflow-hidden" };
const _hoisted_4 = { class: "flex items-center gap-3" };
const _hoisted_5 = { class: "font-mono text-sm uppercase tracking-widest opacity-70" };
const _hoisted_6 = { class: "space-y-[-0.1em] mb-12" };
const _hoisted_7 = { class: "text-5xl md:text-8xl lg:text-9xl font-bold uppercase tracking-tighter leading-[1.05] pt-[0.05em]" };
const _hoisted_8 = { class: "text-5xl md:text-8xl lg:text-9xl font-bold uppercase tracking-tighter leading-[1.05] pt-[0.05em] text-gray-400 dark:text-gray-600" };
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-12 gap-8 mt-16 border-t border-black/10 dark:border-white/10 pt-8" };
const _hoisted_10 = { class: "md:col-span-7" };
const _hoisted_11 = { class: "text-xl md:text-2xl leading-relaxed font-light opacity-90" };
const _hoisted_12 = { class: "md:col-span-5 flex flex-col justify-between h-full" };
const _hoisted_13 = { class: "flex gap-4 md:justify-end" };
const _hoisted_14 = {
    href: "#projects",
    class: "group relative inline-flex h-12 items-center justify-center overflow-hidden bg-black dark:bg-white px-8 font-medium text-white dark:text-black transition-all duration-300 hover:bg-accent dark:hover:bg-accent hover:text-white hover:w-48 rounded-none"
};
const _hoisted_15 = { class: "uppercase tracking-wider text-sm whitespace-nowrap" };
import { computed } from 'vue';
import { CONTENT } from '../constants';
import { useLanguage } from '../composables/useLanguage';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Hero',
    setup(__props) {
        const { language } = useLanguage();
        const text = computed(() => CONTENT[language.value]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "w-2 h-2 bg-accent animate-pulse" }, null, -1 /* CACHED */)),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(text.value.role), 1 /* TEXT */)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", null, [
                            _createElementVNode("h1", _hoisted_7, _toDisplayString(text.value.hero.line1), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("h1", _hoisted_8, _toDisplayString(text.value.hero.line2), 1 /* TEXT */)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("p", _hoisted_11, _toDisplayString(text.value.about), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("a", _hoisted_14, [
                                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute inset-0 flex h-full w-full justify-center [transform:skew(-12deg)_translateX(-100%)] group-hover:duration-1000 group-hover:[transform:skew(-12deg)_translateX(100%)]" }, [
                                        _createElementVNode("div", { class: "relative h-full w-8 bg-white/20" })
                                    ], -1 /* CACHED */)),
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(text.value.hero.cta), 1 /* TEXT */)
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
